import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { ComAndSuggDetailPage } from '../com-and-sugg-detail/com-and-sugg-detail';
import moment from 'moment';

interface ComAndSugg {
  comments: string,
  date: Date,
  dateStr: string,
  type: string,
  checked: boolean,
  user: {
    name: string,
    email: string,
    email2: string,
    sex: string,
    company: string,
    dob: string,
    ocupation: string,
    phone: string
  }
}

@IonicPage()
@Component({
  selector: 'page-com-and-sugg-list',
  templateUrl: 'com-and-sugg-list.html',
})
export class ComAndSuggListPage {

  public relationship = "complaints";
  private complaintsCollection: AngularFirestoreCollection<ComAndSugg>;
  public complaints: ComAndSugg[];
  private suggestionsCollection: AngularFirestoreCollection<ComAndSugg>;
  public suggestions: ComAndSugg[];

  constructor(public navCtrl: NavController, public navParams: NavParams, private fire: AngularFirestore, private modalCtrl: ModalController) {
    this.init();
  }

  init() {
    moment.locale("es");
    this.initComplaints();
    this.initSuggestion();
  }

  initComplaints() {
    this.complaintsCollection = this.fire.collection("complaintsAndSuggestions", ref => ref.where("type", "==", "complaint").orderBy("date", "desc").limit(150));
    this.complaintsCollection.snapshotChanges().subscribe(snap => {
      this.complaints = snap.map(element => {
        let data = element.payload.doc.data() as ComAndSugg;
        data.dateStr = moment(data.date ? data.date : new Date()).format("DD MMM YYYY hh:mm:ss a");
        const id = element.payload.doc.id;
        return { id, ...data }
      });
    }, (error) => {
      console.error(error);
    });
  }

  initSuggestion() {
    this.suggestionsCollection = this.fire.collection("complaintsAndSuggestions", ref => ref.where("type", "==", "suggestion").orderBy("date", "desc").limit(150));
    this.suggestionsCollection.snapshotChanges().subscribe(snap => {
      this.suggestions = snap.map(element => {
        let data = element.payload.doc.data() as ComAndSugg;
        data.dateStr = moment(data.date ? data.date : new Date()).format("DD MMM YYYY hh:mm:ss a");
        const id = element.payload.doc.id;
        return { id, ...data }
      });
    }, (error) => {
      console.error(error);
    });
  }

  ionViewDidLoad() { }

  cancel() {
    this.navCtrl.pop();
  }

  detail(id: string) {
    let modal = this.modalCtrl.create(ComAndSuggDetailPage, { "id": id });
    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/com-and-sugg-list/com-and-sugg-list.ts